import React, { Component } from "react";
import { Card, Dimmer, Loader, Feed, Table } from "semantic-ui-react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import * as HomeAction from "../homePage/homePageActions";
import "rc-pagination/assets/index.css";
import LazyLoad from "react-lazyload";

class MoreBookmarks extends Component {
  componentDidMount() {
    const { homeActions } = this.props;
    homeActions.onGetActiveBookmarkSites();
  }

  renderActiveBookmarkSites(bookmarkLists) {
    if (bookmarkLists && bookmarkLists.length > 0) {
      return bookmarkLists.map(bookmarks => {
        return (
          <Table.Row>
            <Table.Cell>
              <a href={`https://${bookmarks}/`}>
                <font color="black" size="3">
                  {`https://${bookmarks}/`}
                </font>
              </a>
            </Table.Cell>
          </Table.Row>
        );
      });
    }
  }

  render() {
    const { isLoading, activeBookmarkSites } = this.props;

    return (
      <div style={{ width: "100%", display: "inline-block" }}>
        <div style={{ width: "100%", marginTop: "10px", float: "left" }}>
          <Dimmer.Dimmable dimmed={isLoading}>
            <div style={{ height: 20 }}>
              <Dimmer active={isLoading} inverted={true}>
                <Loader>Loading</Loader>
              </Dimmer>
            </div>

            <div
              style={{
                width: "100%",

                textAlign: "center"
              }}
            >
              <div
                style={{
                  width: "25%",
                  wordWrap: "break-word",
                  textAlign: "center",
                  display: "inline-flex"
                }}
              >
                <Card fluid>
                  <Card.Content>
                    <Card.Header>More Bookmarks Websites</Card.Header>
                  </Card.Content>
                  <Card.Content extra>
                    <Feed>
                      <div style={{ width: "100%" }}>
                        <div
                          style={{
                            width: "100%",
                            marginTop: "10px",
                            textAlign: "center"
                          }}
                        >
                          <div>
                            {/* <font size="4" color="black">
                              Download android or iphone app to submit URL. It's free
                            </font> */}
                          </div>
                          {/* <div style={{ paddingTop: "5px" }}>
                            <font size="4" color="red">
                              You can use same credentials
                            </font>
                          </div> */}
                          {/* <div>
                            <LazyLoad resize>
                              <a href="https://play.google.com/store/apps/details?id=com.socialbookmarker">
                                <img
                                src={process.env.PUBLIC_URL + '/playstore.png'}
                                  style={{
                                    width: "40%",
                                    height: "40%",
                                    paddingTop: "5%"
                                  }}
                                />
                              </a>
                              <a href="https://apps.apple.com/app/social-bookmarker/id1514832913">
                              <img
                                src={process.env.PUBLIC_URL + '/appstore.png'}
                                style={{
                                  width: "35%",
                                  height: "40%",
                                  paddingTop: "5%"
                                }}
                              />
                            </a>
                            </LazyLoad>
                          </div> */}
                        </div>
                        <Table
                          singleLine
                          stackable
                          fixed
                          color="green"
                          size="large"
                        >
                          <Table.Header>
                            <Table.Row>
                              <Table.HeaderCell>Back-links</Table.HeaderCell>
                            </Table.Row>
                          </Table.Header>
                          <Table.Body>
                            {this.renderActiveBookmarkSites(
                              activeBookmarkSites
                            )}
                          </Table.Body>
                        </Table>
                      </div>
                    </Feed>
                  </Card.Content>
                </Card>
              </div>
            </div>
          </Dimmer.Dimmable>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ homePage }) => {
  const {
    isLoading,
    bookmarkLists,
    totalBookmarks,
    activeBookmarkSites
  } = homePage;
  return {
    isLoading,
    bookmarkLists,
    totalBookmarks,
    activeBookmarkSites
  };
};

const mapDispatchToProps = dispatch => {
  return {
    homeActions: bindActionCreators(HomeAction, dispatch)
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MoreBookmarks));
